module.exports = __webpack_public_path__ + "img/icon-instagram-footer.f63585ba.svg";